import { styled } from 'styled-components'

import { crmAppLayout } from 'core/styles/layout'
import { surface } from 'core/styles/tokens'

const NAVIGATION_WIDTH = 280

// New unified layout components
export const Container = styled.div`
  display: grid;
  grid-template-rows: auto 1fr;
  background-color: ${surface};
  height: 100vh;
  overflow: hidden;
`

export const TopNav = styled.div`
  z-index: 10;
  width: 100%;
`

export const BodyContainer = styled.div`
  box-sizing: border-box;
  display: flex;
  margin: 0 auto;
  padding: 0 24px;
  width: 100%;
  max-width: ${crmAppLayout.maxWidthMain};
  height: 100%;
  overflow: hidden;
`

export const SideNav = styled.div`
  flex-shrink: 0;
  background-color: ${surface};
  padding: 24px 0;
  width: ${NAVIGATION_WIDTH}px;
  height: 100%;
  overflow-y: auto;
`

export const MainContent = styled.div<{ $padding?: string }>`
  box-sizing: border-box;
  flex: 1;
  background-color: ${surface};
  padding: ${({ $padding }) => $padding ?? '32px 0 24px 24px'};
  width: 100%;
  max-width: ${crmAppLayout.maxWidthMain};
  height: 100%;
  overflow-y: auto;

  /* Hide scrollbar but keep scroll functionality */
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
  &::-webkit-scrollbar {
    /* Chrome, Safari, Opera */
    display: none;
  }
`

// Legacy layout components (for backward compatibility)
// Note: These are kept for potential future use but are currently unused

export const Actions = styled.div`
  display: flex;
  position: relative;
  justify-content: space-between;
  z-index: 10;
  margin-bottom: 16px;
`
